import { useApproveDenyRequestsMutation } from '../../../services/graphql/api';
import { getApplDetailParams } from "../../../util/functions";
import MenuDialogBase from "./MenuDialogBase";

export default function DialogStudentRequestApproveAppeal({ menuItemAndClose, buttonLabel, isApproved = false, requestType }) {
  // approve appeal, and cancel prog change / withdraw / appeal
  const [apiCall, result] = useApproveDenyRequestsMutation();

  const variablesFn = () => {
    const { applicantEmployeeId, programId, term } = getApplDetailParams();
    const applicantEmployeeIds = [applicantEmployeeId];
    return {
      applicantEmployeeIds,
      programId,
      term,
      requestType,
      isApproved,
    }
  };

  const buttons = [{ label: buttonLabel, apiCall, result, variablesFn }];
  const extraContent = <></>;

  return (
    <MenuDialogBase menuItemAndClose={menuItemAndClose}
      apiCall={apiCall}
      buttons={buttons}
      result={result}
      extraContent={extraContent}
    />
  );
}